import { ReactElement, ReactNode } from "react";
import { AperitifPreset } from "lib/api/aperitifMenu";

interface AperitifPresetListItemProps {
    preset: AperitifPreset;
    onClick: (preset: AperitifPreset) => void;
    language: string;
    left?: ReactNode;
}

export function AperitifPresetListItem({ preset, onClick, language, left }: AperitifPresetListItemProps): ReactElement {
    const { body } = preset;
    const name = body.name?.[language] ?? body.name?.["de"];
    const description = body.description?.[language] ?? body.description?.["de"];

    return (
        <button
            className="w-full flex items-center gap-4 p-4 bg-white rounded-lg hover:bg-warm-gray transition-colors text-left"
            onClick={() => onClick(preset)}
        >
            {left}
            <div className="w-12 h-12 flex-shrink-0 bg-white rounded-lg overflow-hidden">
                {body.imageUrl && (
                    <img src={body.imageUrl} alt={name} className="w-full h-full object-contain" />
                )}
            </div>
            <div className="flex-1 min-w-0">
                <div className="font-medium mb-1">{name}</div>
                {description && (
                    <div className="text-sm line-clamp-1">{description}</div>
                )}
            </div>
            {body.price != null && (
                <div className="text-sm flex-shrink-0">
                    {body.price}
                </div>
            )}
        </button>
    );
}
